import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';
import $window from '../tools/window';

const useHandleCategoryParentId = (newParentCatId = '') => {
  const [parentCatId, setParentCatId] = useLocalStorage('parentCategoryIdUsed');

  const setParentCatIdToLS = useCallback((newParentCatIdV2) => {
    setParentCatId(newParentCatId || newParentCatIdV2);
  }, [newParentCatId, setParentCatId]);

  const setParentCatIdToDataBridge = useCallback(() => {
    if ($window.digitalData && parentCatId) {
      $window.digitalData.set('category.parentCategoryId', parentCatId);
      setParentCatId(null);
    }
  }, [parentCatId, setParentCatId]);

  const addHandlersToEspotLinks = useCallback((espotEl) => {
    const accordionPanelElements = espotEl.querySelectorAll('a');
    accordionPanelElements.forEach((element) => element.addEventListener('click', setParentCatIdToLS));
  }, [setParentCatIdToLS]);

  return { setParentCatIdToLS, setParentCatIdToDataBridge, addHandlersToEspotLinks };
};

export default useHandleCategoryParentId;
